import React, { ReactNode, useState } from 'react';

import { UiComponent } from 'components';
import * as M from 'styles/mobile';
import { IStickerListItem } from 'types';
import GrantSheet from './GrantSheet';
import HoldersSheet from './HoldersSheet';
import * as S from './style';

interface Props {
  title?: ReactNode;
  data: IStickerListItem[];
  isLoading?: boolean;
}

function MobileList({ title, data, isLoading }: Props) {
  const [grantTarget, setGrantTarget] = useState<IStickerListItem | null>(null);
  const [holdersTarget, setHoldersTarget] = useState<IStickerListItem | null>(
    null,
  );

  return (
    <>
      <div css={M.stickyTop}>{title}</div>
      <div css={M.list}>
        {data.map((sticker) => (
          <div key={sticker.id} css={S.row}>
            <img css={S.image} src={sticker.imageUrl} alt={sticker.name} />
            <div css={S.info}>
              <p css={S.name}>{sticker.name}</p>
              {sticker.acquisitionGuide && (
                <p css={S.meta}>{sticker.acquisitionGuide}</p>
              )}
              <p css={S.meta}>보유 {sticker.holderCount.toLocaleString()}명</p>
            </div>
            <div css={S.actions}>
              <UiComponent.Button
                variant="contained"
                color="primary"
                css={S.action}
                onClick={() => setGrantTarget(sticker)}
              >
                지급
              </UiComponent.Button>
              <UiComponent.Button
                variant="border"
                color="primary"
                css={S.action}
                onClick={() => setHoldersTarget(sticker)}
              >
                지급내역
              </UiComponent.Button>
            </div>
          </div>
        ))}
        {!isLoading && data.length === 0 && (
          <p css={M.empty}>등록된 스티커가 없습니다</p>
        )}
      </div>
      {holdersTarget && (
        <HoldersSheet
          sticker={holdersTarget}
          onClose={() => setHoldersTarget(null)}
        />
      )}
      {grantTarget && (
        <GrantSheet
          sticker={grantTarget}
          onClose={() => setGrantTarget(null)}
        />
      )}
    </>
  );
}

export default MobileList;
